import { TRUST } from "@/lib/content";
import { Reveal, MaskedLines } from "@/components/motion/Reveal";
import { useTestimonials } from "@/hooks/useData";

export function Trust() {
  const { data: testimonials = [] } = useTestimonials();
  return (
    <section className="bg-paper py-28 md:py-40 border-t border-line" aria-labelledby="trust-title">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Reveal>
              <p className="label text-mute mb-6 flex items-center gap-4"><span className="w-6 h-px bg-ink/40" /> 08 · Vertrauen</p>
            </Reveal>
            <MaskedLines as="h2" id="trust-title" lines={["Worauf Sie", "sich verlassen", "können."]} className="display text-4xl sm:text-5xl lg:text-6xl text-ink" />
            <Reveal delay={0.2} className="mt-8">
              <p className="text-sm md:text-base text-mute leading-relaxed max-w-sm">Wir arbeiten in Ihrem Zuhause und in Ihrem Betrieb. Das setzt Vertrauen voraus. Wir verdienen es mit jedem Einsatz neu.</p>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <dl className="grid sm:grid-cols-2 border-t border-l border-line">
              {TRUST.map((t, i) => (
                <Reveal key={t.t} delay={i * 0.05} className="border-b border-r border-line p-8 md:p-10 group hover:bg-white transition-colors duration-700">
                  <dt className="flex items-baseline gap-4">
                    <span className="label text-mute group-hover:text-signal transition-colors duration-500">0{i + 1}</span>
                    <span className="display text-2xl md:text-3xl text-ink">{t.t}</span>
                  </dt>
                  <dd className="text-sm text-mute leading-relaxed mt-4 pl-10">{t.d}</dd>
                </Reveal>
              ))}
            </dl>
          </div>
        </div>

        {testimonials.length > 0 && (
          <div className="mt-24 grid md:grid-cols-3 gap-8" data-testid="testimonials">
            {testimonials.map((t) => (
              <Reveal key={t.id} className="border-t border-line pt-6">
                <p className="display text-xl md:text-2xl leading-snug text-ink">«{t.quote}»</p>
                <p className="label text-mute mt-6">{t.name}{t.role ? ` · ${t.role}` : ""}</p>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
